import { ApiError } from './api-client/api-error'

// 0 is the status code for hidden redirects (e.g. unauthenticated requests)
const AUTH_ERROR_STATUS_CODES = [499, 401, 302, 0]
const EXPECTED_ERROR_STATUS_CODES = [499, 401]
const FORBIDDEN_ERROR_STATUS_CODE = 403

export function isAuthError(error: unknown) {
  return error instanceof ApiError && AUTH_ERROR_STATUS_CODES.includes(error.status)
}

export function isExpectedError(error: unknown) {
  return error instanceof ApiError && EXPECTED_ERROR_STATUS_CODES.includes(error.status)
}

export function isForbiddenError(error: unknown) {
  return error instanceof ApiError && error.status === FORBIDDEN_ERROR_STATUS_CODE
}
